// src/routes/index.js
// This file combines all route modules in one place.
// Like GEMS's routes/DashboardRoutes.js — one central place for all routes.
// To add a new module: create a new route file and import it here. That's it.

import { Routes, Route } from "react-router-dom";
import authRoutes     from "./authRoutes";
import adminRoutes    from "./adminRoutes";
import employeeRoutes from "./employeeRoutes";

function AppRoutes() {
  return (
    <Routes>

      {/* Public pages — no login needed (login, reset password etc.) */}
      {authRoutes}

      {/* Admin protected pages (dashboard, reporting, onboard/deboard) */}
      {adminRoutes}

      {/* Employee protected pages (employee dashboard, daily reporting) */}
      {employeeRoutes}

      {/* 404 — if someone visits an unknown URL */}
      <Route
        path="*"
        element={
          <div style={{ textAlign: "center", padding: "80px" }}>
            <h2>404 - Page Not Found</h2>
            <a href="/">Go to Login</a>
          </div>
        }
      />

    </Routes>
  );
}

export default AppRoutes;
